import React from 'react';
import ModelpackList from '../../components/modelpacks/ModelpackList';

const Modelpacks: React.FC = () => {

    return (<div>
        <ModelpackList />
    </div>)
};

export default Modelpacks;